import { storageService } from '@/services/storageService'

export default ({ app }) => {
  const tasks = [
    {
      key: 'verifyBonuses',
      delayMs: 3 * 60 * 1000, // 3 мин
      repeatMs: 24 * 60 * 60 * 1000, // 24 часа
      predicate: ({ route, store }) => {
        const isDisallowModal = storageService.getItem('disallow-verify-modal')
        const isBlockedRoute = ['/profile', '/cashbox', 'verifications'].some(path => route.fullPath.includes(path))
        const isLoggedIn = store.getters['user/isLoggedIn']
        const isVerified = store.getters['user/isUserVerified']
        return isLoggedIn && !isVerified && !isBlockedRoute && !isDisallowModal
      },
      callback: ({ store, route, predicate }) => {
        setTimeout(() => {
          if (predicate({ store, route })) {
            store.dispatch('globalModal/open_globalModalVerificationBonuses')
          }
        }, 500)
      },
    },
  ]

  const checkTask = (task) => {
    const key = task.key
    const now = Date.now()

    const startKey = `timer:${key}:startTime`
    const execKey = `timer:${key}:lastExecution`

    const startTime = parseInt(storageService.getItem(startKey) || `${now}`)
    const lastExec = parseInt(storageService.getItem(execKey) || '0')

    const delayPassed = now - startTime >= task.delayMs
    const repeatPassed = now - lastExec >= task.repeatMs

    const route = app.router.currentRoute
    const store = app.store

    const predicateOk = task.predicate({ store, route })
    const shouldRun = delayPassed && repeatPassed && predicateOk

    if (shouldRun) {
      task.callback({ store, route, predicate: task.predicate })
      storageService.setItem(execKey, now.toString())
    }

    return {
      key,
      delayPassed,
      repeatPassed,
      predicateOk,
      shouldRun,
      delayRemaining: Math.max(0, task.delayMs - (now - startTime)),
      repeatRemaining: Math.max(0, task.repeatMs - (now - lastExec)),
    }
  }

  // инициализация всех задач
  tasks.forEach(task => {
    const startKey = `timer:${task.key}:startTime`
    storageService.setItem(startKey, Date.now().toString())

    // периодическая проверка
    setInterval(() => checkTask(task), 5000)

    // реакция на логин
    app.store.watch(
      () => app.store.getters['user/isLoggedIn'],
      () => checkTask(task)
    )

    // реакция на смену роута
    app.router.afterEach(() => {
      checkTask(task)
    })
  })

  // DEBUG: $featureTimerDebug
  window.$featureTimerDebug = () => {
    console.group('🧭 Feature Timer Debug')
    tasks.forEach(task => {
      const info = checkTask(task)
      console.log(`🕓 ${info.key}:`)
      console.log(`  - Predicate OK: ${info.predicateOk}`)
      console.log(`  - Delay Passed: ${info.delayPassed}`)
      console.log(`  - Repeat Passed: ${info.repeatPassed}`)
      console.log(`  - Delay Remaining: ${Math.ceil(info.delayRemaining / 1000)}s`)
      console.log(`  - Repeat Remaining: ${Math.ceil(info.repeatRemaining / 1000)}s`)
      console.log(`  - Should Run: ${info.shouldRun}`)
    })
    console.groupEnd()
  }
}
